<template>
  <div class="basic-layout-wrapper">
    <pro-layout :menus="menus" :collapsed="collapsed" :mediaQuery="query" :isMobile="isMobile"
      :handleMediaQuery="handleMediaQuery" :handleCollapse="handleCollapse" :i18nRender="i18nRender" 
      :menu-item-render="menuItemRender" v-bind="settings">
      <template v-slot:menuHeaderRender>
        <logo-svg v-if="collapsed" />
        <LogoManager v-show="!collapsed && showLogo === 'true'" style="width:160px;height:40px;" />
      </template>
      <template v-slot:headerContentRender>
        <div>
          <a-tooltip title="刷新页面">
            <a-icon type="reload" style="font-size: 18px;cursor: pointer;" @click="() => {
              $router.go(0)
            }
            " />
          </a-tooltip>
          <span style="margin-left:20px;font-size:18px;">{{ systemName }}</span>
        </div>
      </template>

      <setting-drawer v-if="isDev" :settings="settings" @change="handleSettingChange">
        <div style="margin: 12px 0;">This is SettingDrawer custom footer content.</div>
      </setting-drawer>
      <template v-slot:rightContentRender>
        <right-content :top-menu="settings.layout === 'topmenu'" :is-mobile="isMobile" :theme="settings.theme" />
      </template>
      <!-- custom footer / 自定义Footer -->
      <template v-slot:footerRender>
        <global-footer />
      </template>
      <router-view />
    </pro-layout>
    <!-- 侧边栏底部版本号显示（随侧边栏 collapsed 状态变化） -->
    <div class="sidebar-version" :class="{ 'sidebar-version-collapsed': collapsed }" v-if="currentVersion">
      <div class="version-text">版本号: {{ currentVersion }}</div>
    </div>
  </div>
</template>

<script>
import { SettingDrawer } from '@ant-design-vue/pro-layout'
// import { updateTheme } from '@/components/SettingDrawer/settingConfig'
import { i18nRender } from '@/locales'
import { mapState } from 'vuex'
import { CONTENT_WIDTH_TYPE, SIDEBAR_TYPE, TOGGLE_MOBILE_TYPE } from '@/store/mutation-types'

import defaultSettings from '@/config/defaultSettings'
import RightContent from '@/components/GlobalHeader/RightContent'
import GlobalFooter from '@/components/GlobalFooter'
import LogoSvg from '@/assets/myImg/1/合汇LOGO-渐变.svg?inline'
import LogoManager from '@/assets/myImg/logoManager.svg?inline'

export default {
  name: 'BasicLayout',
  components: {
    SettingDrawer,
    RightContent,
    GlobalFooter,
    LogoSvg,
    LogoManager
  },
  data() {
    return {
      showLogo: process.env.VUE_APP_LOGO,
      // preview.pro.antdv.com only use.
      isProPreviewSite: process.env.VUE_APP_PREVIEW === 'true' && process.env.NODE_ENV !== 'development',
      // end
      isDev: process.env.NODE_ENV === 'development',

      // base
      // menus: [],
      // 侧栏收起状态
      collapsed: false,
      title: this.$store.state.user.info.tenant.shortName,
      settings: {
        // 布局类型
        layout: defaultSettings.layout, // 'sidemenu', 'topmenu'
        // CONTENT_WIDTH_TYPE
        contentWidth: defaultSettings.layout === 'sidemenu' ? CONTENT_WIDTH_TYPE.Fluid : defaultSettings.contentWidth,
        // 主题 'dark' | 'light'
        theme: defaultSettings.navTheme,
        // 主色调
        primaryColor: defaultSettings.primaryColor,
        fixedHeader: defaultSettings.fixedHeader,
        fixSiderbar: defaultSettings.fixSiderbar,
        colorWeak: defaultSettings.colorWeak,

        hideHintAlert: false,
        hideCopyButton: false
      },
      // 媒体查询
      query: {},

      // 是否手机模式
      isMobile: false,
      
      // 系统版本号相关
      systemList: [], // 系统列表
      currentVersion: '' // 当前系统版本号
    }
  },
  computed: {
    ...mapState({
      // 动态主路由
      mainMenu: state => state.permission.addRouters,
      currentApp: state => state.permission.currentApp,
      systemName: state => state.app.systemName
    }),
    menus() {
      console.log('menus', this.currentApp);
      
      const routes = this.mainMenu.find(item => item.path === '/')
      const allMenus = (routes && routes.children) || []
      const menus = this.currentApp
        ? allMenus.filter(item => {
          return item.meta && item.meta.appCode == this.currentApp
        })
        : []
      return menus
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.$store.commit('SET_CURRENT_APP', to.matched[1].meta.appCode))
  },
  created() {
    // 处理侧栏收起状态
    this.$watch('collapsed', () => {
      this.$store.commit(SIDEBAR_TYPE, this.collapsed)
    })
    this.$watch('isMobile', () => {
      this.$store.commit(TOGGLE_MOBILE_TYPE, this.isMobile)
    })
    this.$watch('$route', (nv, ov) => {
      this.$store.commit('SET_CURRENT_APP', nv.matched[1].meta.appCode)
      // 路由变化时查询版本号
      this.$nextTick(() => {
        this.querySystemVersion()
      })
    })
    // 监听 currentApp 变化
    this.$watch('currentApp', () => {
      this.querySystemVersion()
    })
    // 初始化时获取系统列表和版本号
    this.getSystemList()
  },
  mounted() {
    const userAgent = navigator.userAgent
    if (userAgent.indexOf('Edge') > -1) {
      this.$nextTick(() => {
        this.collapsed = !this.collapsed
        setTimeout(() => {
          this.collapsed = !this.collapsed
        }, 16)
      })
    }

    // 修改主题更新的调用
    // if (this.settings.primaryColor) {
    //   updateTheme(this.settings.primaryColor)
    //     .catch(error => {
    //       console.error('初始化主题失败:', error)
    //     })
    // }
    
    // 初始化时查询版本号
    this.$nextTick(() => {
      this.querySystemVersion()
    })
  },
  methods: {
    i18nRender,
    // 获取系统列表
    getSystemList() {
      console.log(666);
      
      this.$http
        .get('/manager/users/app')
        .then((res) => {
          if (res.code === 0 || res.code === 200) {
            this.systemList = res.data || []
            // 获取系统列表后查询版本号
            this.querySystemVersion()
          }
        })
        .catch(() => {})
    },
    // 查询系统版本号
    querySystemVersion() {  
      console.log('querySystemVersion');
          
      // 如果没有 currentApp，不查询
      if (!this.currentApp) {
        this.currentVersion = ''
        return
      }
      
      // 从系统列表中查找对应的系统ID
      
      const system = this.systemList.find(item => item.appCode === this.currentApp)
      
      if (!system || !system.id) {
        this.currentVersion = ''
        return
      }
      
      // 调用接口查询版本号
      this.$http
        .get('/manager/sys_update_log/selectSysVersionNum', {
          params: {
            id: system.id
          }
        })
        .then((res) => {
          if (res.code === 0 || res.code === 200) {
            this.currentVersion = res.msg || ''
          } else {
            this.currentVersion = ''
          }
        })
        .catch(() => {
          this.currentVersion = ''
        })
    },
    menuItemRender(menuItemProps, defaultDom) {
      // 如果路由 meta 中有 target: '_blank'，则在新标签页打开
      try {
        // pro-layout 的 menuItemRender 参数可能是 { item, dom } 或直接是 item
        const item = menuItemProps.item || menuItemProps
        const path = item.path || (item.route && item.route.path)
        
        // 检查 meta 中的 target 或者直接检查工作台路径
        const shouldOpenInNewTab = (item && item.meta && item.meta.target === '_blank') || 
                                   path === '/partition/workbench'
        
        if (shouldOpenInNewTab && path) {
          const routeUrl = this.$router.resolve(path)
          return this.$createElement('a', {
            style: { cursor: 'pointer', display: 'block', width: '100%' },
            on: {
              click: (e) => {
                e.preventDefault()
                e.stopPropagation()
                if (routeUrl && routeUrl.href) {
                  window.open(routeUrl.href, '_blank')
                }
              }
            }
          }, [defaultDom])
        }
      } catch (error) {
        console.error('menuItemRender error:', error, menuItemProps)
      }
      return defaultDom
    },
    handleMediaQuery(val) {
      this.query = val
      if (this.isMobile && !val['screen-xs']) {
        this.isMobile = false
        return
      }
      if (!this.isMobile && val['screen-xs']) {
        this.isMobile = true
        this.collapsed = false
        this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fluid
        // this.settings.fixSiderbar = false
      }
    },
    handleCollapse(val) {
      this.collapsed = val
    },
    handleSettingChange({ type, value }) {
      type && (this.settings[type] = value)
      switch (type) {
        case 'contentWidth':
          this.settings[type] = value
          break
        case 'layout':
          if (value === 'sidemenu') {
            this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fluid
          } else {
            this.settings.fixSiderbar = false
            this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fixed
          }
          break
      }
    }
  }
}
</script>

<style lang="less">
.logo {
  position: absolute;
  left: 3.2%;
  top: 3.9%;
  width: 14.7%;
  height: 6.5%;
  background-size: 100% 100%;
}

@import './BasicLayout.less';
</style>
